import type { GroupId, ViewModelId, ViewModelTagId, ViewModelTagJSON } from 'balus-common';
import { RTDBPath } from 'balus-common';
import { useSnapshot } from '@framework/hooks/useSnapshot';
import { useEffect, useState } from 'react';

type AssignedViewModelTag = {
  id: string;
  name: string;
};

export const useAssignedViewModelTags = (groupId: GroupId, viewModelId: ViewModelId) => {
  const [tagList, setTagList] = useState<AssignedViewModelTag[]>([]);

  const [assignedTags] = useSnapshot<Record<ViewModelTagId, Record<ViewModelId, string>>>({
    path: RTDBPath.ViewModelTags.tagsAssignedViewModelsGroupPath(groupId),
    load: ({ snapshot }) => snapshot.val() || {},
  });

  const [tagEntities] = useSnapshot<Record<ViewModelTagId, ViewModelTagJSON>>({
    path: RTDBPath.ViewModelTags.tagsEntitiesPath(groupId),
    load: ({ snapshot }) => snapshot.val() || {},
  });

  useEffect(() => {
    async function init() {
      const assignedTagIds: ViewModelTagId[] = [];

      for (const [key, value] of Object.entries(assignedTags || {})) {
        const assignedViewModelIds = Object.keys(value);
        if (assignedViewModelIds.includes(viewModelId)) {
          assignedTagIds.push(key);
        }
      }

      if (tagEntities === null) {
        setTagList([]);
      } else {
        const tags: AssignedViewModelTag[] = [];
        for (const entity of Object.values(tagEntities || {})) {
          if (assignedTagIds.includes(entity.id)) {
            tags.push({ id: entity.id, name: entity.name });
          }
        }
        setTagList(tags.sort((a, b) => a.name.localeCompare(b.name)));
      }
    }

    init();
  }, [assignedTags, groupId, tagEntities, viewModelId]);

  return { tagList };
};
